import React from "react"

const AppLoadingAnimation = () => {
  return <i className="app-loading-animation" />
}

export default AppLoadingAnimation
